import React, { useState } from "react";
import { Filter, RotateCw, CircleCheckBig } from "lucide-react";
import CollapsibleSection from "./CollapsibleSection";
import MultiSelectDropdown from "./MultiSelectDropdown";
import MultiSelectDropdownKpiType from "./MultiSelectDropdownKpiType";

export const SectionsSidebar = ({
  sections,
  selectedSections,
  onSectionsChange,
  kpiTypes,
  selectedKpiTypes,
  onKpiTypesChange,
  onSubmit,
  clearFilter,
  kpiTypeOption
}) => {
  const [openSection, setOpenSection] = useState("sections");

  const handleToggleSection = (sectionId) => {
    setOpenSection(openSection === sectionId ? null : sectionId);
  };

  const hasFilters =
    selectedSections?.length > 0 || selectedKpiTypes?.length > 0;

  return (
    <div className="w-[400px] h-[687px] flex flex-col bg-[#F9FAFB] border border-gray-200">

      {/* Header */}
      <div className="px-6 py-4 border-b bg-white sticky top-0 z-10">
        <div className="flex items-center justify-between">
          <div className="flex items-start gap-2">
            <Filter className="h-5 text-[#bb1ccc] mt-0.5" />
            <h2 className="text-[15px] font-semibold text-gray-900">
              Filters
            </h2>
          </div>

          <div className="flex items-center gap-3">
            <button
              disabled={!hasFilters}
              onClick={onSubmit}
              className={`px-3 py-2 text-sm font-medium rounded-md shadow-sm transition flex items-center gap-2
    ${hasFilters
                  ? "bg-[#bb1ccc] text-white hover:bg-[#00008b]"
                  : "bg-gray-200 text-gray-500 cursor-not-allowed"
                }`}
            >
              <CircleCheckBig className="h-5 " />
              Apply
            </button>


            <button
              disabled={!hasFilters}
              onClick={clearFilter}
              className={`px-3 py-2 text-sm font-medium rounded-md border transition flex items-center gap-2
    ${hasFilters
                  ? "border-[#bb1ccc] text-[#bb1ccc] hover:bg-[#EEF2FF]"
                  : "border-gray-300 text-gray-400 cursor-not-allowed"
                }`}
            >
              <RotateCw className="h-5 " />
              Clear
            </button>

          </div>
        </div>
      </div>

      {/* Filters Content */}
      <div className="flex-1 overflow-y-auto px-4 py-4 space-y-4">

        <div className="bg-white rounded-lg border border-gray-200 shadow-sm">
          <CollapsibleSection
            title="Sections"
            isOpen={openSection === "sections"}
            onToggle={handleToggleSection}
            sectionId="sections"
          >
            <MultiSelectDropdown
              options={sections}
              selectedItems={selectedSections}
              onChange={onSectionsChange}
              placeholder="Select sections..."
              showIcons
              alwaysShowOptions
            />
          </CollapsibleSection>
        </div>

        <div className="bg-white rounded-lg border border-gray-200 shadow-sm">
          <CollapsibleSection
            title="KPI Types"
            isOpen={openSection === "kpiTypes"}
            onToggle={handleToggleSection}
            sectionId="kpiTypes"
          >
            <MultiSelectDropdownKpiType
              options={kpiTypes}
              selectedItems={selectedKpiTypes}
              onChange={onKpiTypesChange}
              placeholder="Select KPI types..."
              alwaysShowOptions
              kpiTypeOption={kpiTypeOption}
            />
          </CollapsibleSection>
        </div>

      </div>
    </div>
  );
};
